<script setup lang="ts">
/**
 * this is for modals
 * use route query to show panel
 * instead of using the store
 * if panel is a child of a route and not a global panel
 * create a child route for the panel
 */
import TransitionSlide from '@/components/transitions/TransitionSlide.vue';
import ShareProfilePanel from './ShareProfilePanel.vue';
</script>

<template>
  <Teleport to="body">
    <TransitionSlide>
      <ShareProfilePanel v-if="$route.query.share" />
    </TransitionSlide>
  </Teleport>
</template>
